"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FallbackComponent;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var OMITTED = ['stack'];

function stringifyError(error) {
  var alt = Object.getOwnPropertyNames(error).filter(function (p) {
    return !OMITTED.includes(p);
  }).reduce(function (acc, key) {
    return (0, _objectSpread3["default"])({}, acc, (0, _defineProperty2["default"])({}, key, error[key]));
  }, {});
  return JSON.stringify(alt, null, 2);
}

function FallbackComponent(props) {
  var type = props.type,
      error = props.error;
  if (process.env.NODE_ENV === 'production') return null;
  return _react["default"].createElement("div", null, "Failed to load component ", type, _react["default"].createElement("pre", {
    style: {
      overflow: 'auto'
    }
  }, stringifyError(error)));
}